import React from "react";

// Exact Old School RuneScape skills-tab layout (3 columns, read row-by-row).
const IN_GAME_ORDER = [
  "Attack", "Hitpoints", "Mining",
  "Strength", "Agility", "Smithing",
  "Defence", "Herblore", "Fishing",
  "Ranged", "Thieving", "Cooking",
  "Prayer", "Crafting", "Firemaking",
  "Magic", "Fletching", "Woodcutting",
  "Runecraft", "Slayer", "Farming",
  "Construction", "Hunter", "Sailing",
];

export default function SkillsPanel({ snapshot }) {
  const byName = {};
  (snapshot?.skills || []).forEach((s) => { byName[s.name] = s; });
  const overall = byName["Overall"];

  return (
    <div className="osrs-panel p-4" data-testid="skills-panel">
      <h2 className="osrs-title text-lg mb-3 flex items-center justify-between">
        <span>Skills</span>
        <span className="flex items-center gap-2">
          <img src="/skill-icons/overall.png" alt="Total level" width={20} height={20} style={{ imageRendering: "pixelated" }} />
          <span className="osrs-num text-[#00FF00] osrs-shadow text-2xl" data-testid="stat-total-level">
            {overall?.level ?? 0}
          </span>
        </span>
      </h2>
      <div className="grid grid-cols-3 gap-1">
        {IN_GAME_ORDER.map((name) => {
          const s = byName[name] || { name, level: 1 };
          return (
            <div
              key={name}
              className="skill-node flex items-center gap-2 px-2 py-2"
              title={`${name} — Level ${s.level ?? 1} — Rank ${s.rank?.toLocaleString?.() ?? "-"} — ${Number(s.xp || 0).toLocaleString()} XP`}
              data-testid={`skill-${name.toLowerCase()}`}
            >
              <img
                src={`/skill-icons/${name.toLowerCase()}.png`}
                alt={name}
                width={20}
                height={20}
                className="shrink-0"
                style={{ imageRendering: "pixelated" }}
              />
              <span className="osrs-num text-[#FFCF3F] osrs-shadow text-xl leading-none ml-auto">
                {s.level ?? 1}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
